export default "__VITE_ASSET__ada228ef__"